import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { API_BASE_URL } from '../helpers/config';
import PopupNumero from './popUpNumero';
import LoadingLoop from './loadingLoop';
import { coverUrl } from '../helpers/revista';
export default function RevistaQuickView({ onLatestIssue }) {
  const [issues, setIssues] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [selected, setSelected] = useState(null);
  const rail = useRef(null);
  useEffect(() => {
    const controller = new AbortController();
    fetch(`${API_BASE_URL}/api/revista`, {
      signal: controller.signal
    }).then(response => {
      if (!response.ok) throw new Error('Error');
      return response.json();
    }).then(data => {
      if (!Array.isArray(data)) throw new Error('Error');
      const sorted = [...data].sort((a, b) => b.numero - a.numero);
      setIssues(sorted.slice(0, 7));
      if (onLatestIssue) onLatestIssue(sorted[0] || null);
    }).catch(error => {
      if (error.name !== 'AbortError') setError(true);
    }).finally(() => {
      if (!controller.signal.aborted) setLoading(false);
    });
    return () => controller.abort();
  }, [onLatestIssue]);
  if (loading) return <LoadingLoop />;
  if (error) return <div className="empty-state"><p>No pudimos cargar el archivo en este momento.</p><Link className="text-link" to="/numeros">Ir a todos los números →</Link></div>;
  if (!issues.length) return <p className="empty-state">Los próximos números aparecerán aquí.</p>;
  return <>
        <div className="issue-rail" ref={rail}>{issues.map(issue => <button className="issue-card" key={issue._id || issue.numero} onClick={() => setSelected(issue)}><span className="issue-image"><img src={coverUrl(issue)} alt={`Tapa de Boca de Sapo ${issue.numero}`} loading="lazy" /></span><span className="issue-meta">N.º {issue.numero}<span aria-hidden="true">↗</span></span><span className="issue-name">{issue.nombre}</span></button>)}</div>
        <div className="rail-controls"><span>Un recorrido por nuestras ediciones</span><div><button aria-label="Números anteriores" onClick={() => rail.current.scrollBy({
          left: -500,
          behavior: 'smooth'
        })}>←</button><button aria-label="Más números" onClick={() => rail.current.scrollBy({
          left: 500,
          behavior: 'smooth'
        })}>→</button></div></div>
        {selected && <PopupNumero data={selected} img={coverUrl(selected)} deactivate={() => setSelected(null)} />}
    </>;
}
